export const getFileSubPath = (fileName: string) => `data/${fileName}.json`
